module.exports = __webpack_public_path__ + "img/vil-du-vide-mere.5e8886f3.png";